
import { AngleProps, Coord } from "../../../../../../../src/types/Interface";
import { PINK_ANGLE_COLORS } from "../../../types/Config";


const pAC = PINK_ANGLE_COLORS;


export const anglePropsArr: AngleProps[] = Array(8)
	.fill(null)
	.map((_, i) => ({ angleColors: { color: pAC[0], textColor: pAC[1] }, smallDistanceOffset: 20 }));


export function generateAnglePoints(points: Coord[], cCoord: Coord, interSecPoint: Coord, clockwise: boolean) {
	return [
		{ curr: points[0], prev: interSecPoint, next: cCoord, clockwise },
		{ curr: points[1], prev: cCoord, next: interSecPoint, clockwise },
		{ curr: points[1], prev: points[0], next: interSecPoint, clockwise },
		{ curr: points[0], prev: points[1], next: interSecPoint, clockwise: !clockwise },
		{ curr: cCoord, prev: interSecPoint, next: points[0], clockwise: !clockwise },
		{ curr: cCoord, prev: interSecPoint, next: points[1], clockwise },
		{ curr: interSecPoint, prev: cCoord, next: points[0], clockwise },
		{ curr: interSecPoint, prev: cCoord, next: points[1], clockwise: !clockwise },
	];
}